import ShoppingWorkspace from '@/components/google-ads/shopping/ShoppingWorkspace';
import { SHOPPING_OBJECTIVE } from './shoppingObjective';

/** PRODUCT SALES (SHOPPING) WORKSPACE — /google-ads/shopping */
export default function ShoppingPage() {
  return <ShoppingWorkspace cfg={SHOPPING_OBJECTIVE} />;
}
